import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "w-48 h-3 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "h-3 mb-1 bg-primary-100 dark:bg-gray-700 w-45" }, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "w-56 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "w-48 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "h-3 mb-1 bg-primary-100 dark:bg-gray-700 w-45" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "w-48 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "w-40 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "h-3 mb-1 bg-primary-100 dark:bg-gray-700 w-45" }, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("div", { class: "w-56 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "w-48 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "w-56 h-3 mb-1 bg-primary-100 dark:bg-gray-700" }, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", { class: "w-12 h-3 bg-primary-100 dark:bg-gray-700" }, null, -1);
import ActionItemTemplate from '@/components/action_items/ActionItemTemplate.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SkeletonActionItem',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ActionItemTemplate, null, {
                ownerAvatars: _withCtx(() => [
                    _hoisted_1
                ]),
                ownersText: _withCtx(() => [
                    _hoisted_2
                ]),
                body: _withCtx(() => [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11
                ]),
                footer: _withCtx(() => [
                    _hoisted_12,
                    _hoisted_13
                ]),
                _: 1
            }));
        };
    }
});
